/** Helper function to check if two dates are on the same day */
export function isSameDay(date1: Date, date2: Date): boolean {
    if (!date1 || !date2) {
        return false;
    }

    const shortDate1 = new Date(date1).toISOString().split("T")[0];
    const shortDate2 = new Date(date2).toISOString().split("T")[0];
    return shortDate1 === shortDate2;
}

export const emptyDate = new Date("1900-01-01");

export const isEmptyDate = (date: Date | null | undefined): boolean => {
    if (!date) {
        return true;
    }

    return isSameDay(date, emptyDate);
};